/** @jsx dom */
import dom from 'magic-virtual-element';
import Slide from '@viskan/deku-slide';
import {Post} from '../';
import {Image} from '~/media';
import getIcon from '../../utils/actions';

const getPosts = ({badgeOptions, image, imageOnHover, posts}) => posts.map((x, index) => <Post key={`${x.creationDate}-${x.username}`} badgeOptions={badgeOptions} image={image} imageOnHover={imageOnHover} index={index} posts={posts}/>);
const parseNumber = (num, def) => parseInt(num, 10) || def;
const getImage = (stateString, props) => <Image source={props[`image${stateString}`]}/>;
const getPresentation = (stateString, props) => {
	switch (props.type) {
		case 'icon': {
			return getIcon({icon: props[`icon${stateString}`], iconColor: props[`icon${stateString}Color`], iconSize: props[`icon${stateString}Size`], label: stateString});
		}
		case 'image': {
			return getImage(stateString, props);
		}
		case 'text':
		default: {
			return stateString;
		}
	}
};

const onInit = ({activeIndex, onReachEnd, setActiveIndex}) => sliderInstance => {
	sliderInstance.on('reachEnd', () => {
		setActiveIndex(sliderInstance.activeIndex + 1);

		if (sliderInstance.activeIndex === 0 || sliderInstance.activeIndex === activeIndex) {
			return;
		}

		onReachEnd();
	});
};

const shouldUpdate = ({props}, nextProps) => props.posts.length !== nextProps.posts.length || props.columns !== nextProps.columns || props.rows !== nextProps.rows || props.activeIndex !== nextProps.activeIndex || props.image !== nextProps.image || props.imageOnHover !== nextProps.imageOnHover || props.badgeOptions !== nextProps.badgeOptions || props.iconNext !== nextProps.iconNext || props.iconPrev !== nextProps.iconPrev || props.imageNext !== nextProps.imageNext || props.imagePrev !== nextProps.imagePrev;

const render = ({props}) => {
	const {activeIndex, columns, rows} = props;
	const iconNext = (props.iconNext || props.imageNext) && props.type !== 'none' ? getPresentation('Next', props) : '';
	const iconPrev = (props.iconPrev || props.imagePrev) && props.type !== 'none' ? getPresentation('Prev', props) : '';

	const options = {
		initialSlide: activeIndex,
		roundLengths: true,
		slidesPerColumn: rows,
		slidesPerView: columns,
		spaceBetween: parseNumber(props.spaceBetweenSlides, 0)
	};

	const settings = {
		arrows: props.arrows,
		iconNext,
		iconPrev,
		direction: 'horizontal',
		disableOnInteraction: true,
		duration: 3000,
		effect: 'slide',
		loop: false,
		options,
		pagination: false,
		play: false,
		speed: 500,
		timing: 'ease'
	};

	return (
		<div class='InstagramFeed'>
			<Slide options={options} onInit={onInit(props)} {...settings}>
				{getPosts(props)}
			</Slide>
		</div>
	);
};

export default {render, shouldUpdate};
